(function () {
  let metafieldData;
  function changeUnit(row, column, value, unit = "inch") {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const d = 2.54;
    const re1 = new RegExp(/^(\d+(\.\d+)?)-(\d+(\.\d+)?)$/);
    if ((type == "body" && row != 1) || (type == "product" && row != 1)) {
      // console.log(row, column, value)
      if (/^(\d+)(\.\d+)?$/.test(value) && unit != "cm") {
        value = value == 0 ? "0" : change(value);
      } else if (value == "" || value == null) {
        value = "&nbsp;";
      } else if (re1.test(value) && unit != "cm") {
        const res = re1.exec(value);
        value = `${change(res[1])}-${change(res[3])}`;
      }
    }

    function change(v) {
      return (v / d).toFixed(1);
      // return Math.ceil(v / d)
    }

    return value;
  }
  function init() {
    metafieldData = JSON.parse($(".pr_metafield_json").html());
    const html = `
      <h1>Size Guide</h1>
      <div class="guide-entry">
        <img class="icon" src="https://oglmove.com/cdn/shop/t/60/assets/ruler.svg?v=77864277191025910731726841521" width="24" height="24"/>
        <a id="what-my-size-entry" onclick="showModal('Size Guide')" class="t4s-ch title">What's My Size?</a>
      </div>
      <div class="guide_table">
        <div class="switch" unit="inch">
          <h3>Switch to</h3>
          <span class="wrap">
            <span class="name inch hit">IN</span>
            <span class="name cm ">CM</span>
          </span>
        </div>
        <div class="header">
          <span class="size hit" type="size">Size Chart</span>
          <span class="body" type="body">Body Measurements</span>
          <span class="product" type="product">Product Measurements</span>
          <span class="country" type="country">Country / Region</span>
        </div>
        <div class="content">
          <div class="fixed_header"></div>
          <div class="data"></div>
        </div>
      </div>
      <div class="tips">
        <span class='size'>
          <p>${metafieldData["size_guide_model_data"] || ""}</p>
          <p>* This data is suitable for the majority of body types. If your bust size is DD cup, please be cautious when purchasing the brami style.</p>
        </span>
        <span class='others'>* This data was obtained from manually measuring the product, it may be off by 1-2 CM.</span>
      </div>

      <div class="info body">
        <div class="text">
        <h2>How to Measure your Body?</h2>
        <h3><span class="num">1</span>Your bust</h3>
        <p>Measure the circumference over the fullest part of your bust.</p>
        <h3><span class="num">2</span>Your waist</h3>
        <p>Measure your waist at the thinnest place.</p>
        <h3><span class="num">3</span>Your hips</h3>
        <p>Measure the fullest part of your hips.</p>      
        </div>
        <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/body_4d0d979f-d438-4ad8-8694-50b80df94b79.png?v=1692281145"></div>
      </div>

      <div class="info tops">
        <div class="text">
          <h2>How to Measure the Product's Size?</h2>
          <h3><span class="num">1</span>Shoulder</h3>
          <p>Measure from where the shoulder seam meets the sleeve on one side to another side.</p>
          <h3><span class="num">2</span>Bust</h3>
          <p>Measure from the stitches below the armpits on one side to another. Double the measurement for the full bust circumference.</p>
          <h3><span class="num">3</span>Length</h3>
          <p>Measure from where the shoulder seam meets the collar to the hem.</p>
          <h3><span class="num">4</span>Sleeves</h3>
          <p>Measure from where the shoulder seam meets armhole to the cuff.</p>
          <h3><span class="num">5</span>Bicep</h3>
          <p>Measure around the fullest part of the upper arm</p>
          <h3><span class="num">6</span>Cuff</h3>
          <p>Measure the distance from the end of the cuff to the point where the cuff attaches to the sleeve.</p>
          <h3><span class="num">7</span>Hem</h3>
          <p>Measure all the way around the hemline.</p>
        </div>
        <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/top_15d3f5fc-6d3b-48a0-bbb8-034e44217d88.png?v=1692281146"></div>
      </div>

      <div class="info dresses">
        <div class="text">
          <h2>How to Measure the Product's Size?</h2>
          <h3><span class="num">1</span>Shoulder</h3>
          <p>Measure from where the shoulder seam meets the sleeve on one side to another side.</p>
          <h3><span class="num">2</span>Bust</h3>
          <p>Measure from the stitches below the armpits on one side to another. Double the measurement for the full bust circumference.</p>
          <h3><span class="num">3</span>Bicep</h3>
          <p>Measure around the fullest part of the upper arm.</p>
          <h3><span class="num">4</span>Hem</h3>
          <p>Measure all the way around the hemline.</p>
          <h3><span class="num">5</span>Length</h3>
          <p>Measure from where the shoulder seam meets the collar to the hem.</p>
          <h3><span class="num">6</span>Sleeves</h3>
          <p>Measure from where the shoulder seam meets armhole to the cuff.</p>
          <h3><span class="num">7</span>Cuff</h3>
          <p>Measure the distance from the end of the cuff to the point where the cuff attaches to the sleeve.</p>
        </div>
        <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/dress_6473fd21-7512-4a10-b23c-f609b865f7f5.png?v=1692281146"></div>
      </div>

      <div class="info bottoms">
        <div class="text">
          <h2>How to Measure the Product's Size?</h2>
          <h3><span class="num">1</span>Waist</h3>
          <p>Measure straight across the top of the waistband from edge to edge. Double the measurement for the full waist circumference.</p>
          <h3><span class="num">2</span>Hip</h3>
          <p>Measure straight across the widest hip line from edge to edge.Double the measurement for the full hip circumference.</p>
          <h3><span class="num">3</span>Thigh</h3>
          <p>Measure across straight from the crotch seam to the outside of the leg.Double the measurement for the full thigh circumference.</p>
          <h3><span class="num">4</span>Length</h3>
          <p>Measure from the top of the waistband to the hemline.</p>
          <h3><span class="num">5</span>Inseam</h3>
          <p>Measure straight down the inside leg from the crotch to the hem. </p>
        </div>
        <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/bottom_23e0c41d-307c-4fac-90f1-611f4f918579.png?v=1692281145"></div>
      </div>

      <div class="info skirts">
        <div class="text">
          <h2>How to Measure the Product's Size?</h2>
          <h3><span class="num">1</span>Waist</h3>
          <p>Measure straight across the top of the waistband from edge to edge. Double the measurement for the full waist circumference.</p>
          <h3><span class="num">2</span>Hip</h3>
          <p>Measure straight across the widest hip line from edge to edge.Double the measurement for the full hip circumference.</p>
          <h3><span class="num">3</span>Length</h3>
          <p>Measure from the top of the waistband to the hemline.</p>
          <h3><span class="num">4</span>Hem</h3>
          <p>Measure all the way around the hemline.</p>
        </div>
        <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/skri_f89f4af5-9fe9-430a-87ae-df3b48a62fbd.png?v=1692281145"></div>
      </div>
      `;
    $(".mibao_size_guide_2022").html(html);

    if (!metafieldData["sizedata"]) {
      // sizeData没数据
      $(".mibao_size_guide_2022 .guide_table .header span").removeClass("hit");
      $(
        ".mibao_size_guide_2022 .guide_table .header span[type=product]"
      ).addClass("hit");
      $(".mibao_size_guide_2022 .guide_table .header span[type=body").hide();
    }

    makeTable();
    makeInfo();
    // makeImage()

    $(".mibao_size_guide_2022 .guide_table .switch").click(function (e) {
      const unit = $(this).attr("unit");
      const newUnit = unit == "cm" ? "inch" : "cm";
      $(this).attr("unit", newUnit);
      $(this).find(".name").removeClass("hit");
      $(this).find(`.name.${newUnit}`).addClass("hit");
      makeTable();
    });
    $(".mibao_size_guide_2022 .guide_table .header span").click(function (e) {
      $(".mibao_size_guide_2022 .guide_table .header span").removeClass("hit");
      $(this).addClass("hit");
      makeInfo();
      // makeImage()
      makeTable();
    });
  }
  function makeInfo() {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const tags = JSON.parse($(".pr_tags_json").html());
    const product_types = meta.product.type.split(">");
    let info_type;
    if (type == "product") {
      // 上衣tops，连衣裙dress，裤装pants,shorts，半裙skirts，skorts
      if (/tops/i.test(product_types[1])) {
        info_type = "tops";
      } else if (/dresses/i.test(product_types[1])) {
        info_type = "dresses";
      } else if (
        /bottoms/i.test(product_types[1]) &&
        !/skirt/i.test(product_types[2])
      ) {
        info_type = "bottoms";
      } else if (/skirt/i.test(product_types[2])) {
        info_type = "skirts";
      }
    } else if (type == "body") {
      info_type = "body";
    }
    $(".mibao_size_guide_2022 .info").hide();
    if (info_type) {
      $(`.mibao_size_guide_2022 .info.${info_type}`).show();
    }
  }
  function makeImage() {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const tags = JSON.parse($(".pr_tags_json").html());
    let url =
      "//cdn.shopify.com/s/files/1/0506/5284/0124/files/what_s_my_size-02.png?v=1678501600";

    if (tags.indexOf("tops-man") > -1) {
      url =
        "//cdn.shopify.com/s/files/1/0506/5284/0124/files/man-size-guide.jpg?v=1675658077";
    } else {
      if (type == "product") {
        // 上衣tops，连衣裙dress，裤装pants,shorts，半裙skirts，skorts
        if (tags.indexOf("tops") > -1) {
          url =
            "//cdn.shopifycdn.net/s/files/1/0506/5284/0124/files/8129B831-3A02-492F-A6F2-889A50962C8E-11505-0000034F44E9C7C1.png?v=1670311546";
        } else if (tags.indexOf("dress") > -1) {
          url =
            "//cdn.shopifycdn.net/s/files/1/0506/5284/0124/files/41F12119-E89D-4B41-B78B-95E99CDF5CF3-11505-0000034F40127326.png?v=1670311547";
        } else if (tags.indexOf("pants") > -1 || tags.indexOf("shorts") > -1) {
          url =
            "//cdn.shopifycdn.net/s/files/1/0506/5284/0124/files/7D58235D-74EE-410E-928F-16D341C742B5-11505-0000034F3ACEB6CA.png?v=1670311546";
        } else if (tags.indexOf("skirts") > -1 || tags.indexOf("skorts") > -1) {
          url =
            "//cdn.shopifycdn.net/s/files/1/0506/5284/0124/files/642418bc1a2d36dcea39e33f07ac6796.png?v=1670311547";
        }
      }
    }
    // $('.mibao_size_guide_2022 .guide_image img').attr('src', url)
  }
  function makeTable() {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const unit = $(".mibao_size_guide_2022 .guide_table .switch").attr("unit");
    $(".mibao_size_guide_2022 .guide_table .switch").show(0);
    $(".mibao_size_guide_2022 .tips").show(0);
    let sizeData = [];
    let needResize = true;
    if (type == "product" && metafieldData["sizedata"]) {
      const productSizeDataOrigin = metafieldData["sizedata"];
      sizeData = productSizeDataOrigin
        .split("\n")
        .filter((o) => o)
        .map((o, r) => o.split("|").map((v, c) => changeUnit(r, c, v, unit)));
      sizeData[0][0] = "&nbsp;";
    } else if (type == "body") {
      sizeData = [
        ["&nbsp;", "XS", "S", "M", "L", "XL", "2XL"],
        ["US", "00", "2-4", "6-8", "10-12", "14-16", "18"],
        // ["UK/AUS", "4", "6-8", "10-12", "14-16", "16-18", "20"],
        // ["EU", "30-32", "34-36", "38-40", "42-44", "46-48", "50-52"],
        ["BUST", "76-82", "84-90", "86-96", "98-104", "106-112", "114-120"],
        ["WAIST", "56-64", "62-70", "68-76", "74-86", "88-96", "98-106"],
        ["HIP", "86-89", "91-94", "97-100", "102-107", "109-114", "117-122"],
      ].map((o, r) => o.map((v, c) => changeUnit(r, c, v, unit)));
    } else if (type == "size") {
      sizeData = [
        [
          "<span class='w'>weight<br><sub>(LBS)</sub></span><span class='h'>height</span><b>&nbsp<b>",
          "<100",
          "100",
          "120",
          "130",
          "140",
          "150",
          "160",
          "170",
          "180",
          "190",
          "200",
        ],
        ["5'1''", "XS", "S", "S", "S", "M", "M", "L", "L", "XL", "XXL", ""],
        ["5'2''", "XS", "XS", "S", "S", "M", "M", "L", "L", "XL", "XXL", ""],
        ["5'3''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'4''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'5''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'6''", "XS", "S", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'7''", "", "S", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'8''", "", "", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'9''", "", "", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'10''", "", "", "S", "S", "M", "M", "M", "L", "L", "L", "XL"],
        ["5'11''", "", "", "M", "M", "M", "M", "M", "L", "L", "L", "XL"],
        ["6'0''", "", "", "M", "M", "M", "M", "M", "L", "L", "L", "XL"],
      ];
      needResize = false;
      $(".mibao_size_guide_2022 .guide_table .switch").hide(0);
    } else if (type == "country") {
      sizeData = [
        ["&nbsp;", "Numeric size", "US", "EU", "AUS", "UK", "CAN"],
        ["XS", "0", "0", "30-32", "4-6", "4-6", "0"],
        ["S", "2-4", "2-4", "34-36", "8-10", "8-10", "2-4"],
        ["M", "6-10", "6-10", "38-40", "12-14", "12-14", "6-10"],
        ["L", "12-14", "12-14", "42-44", "16-18", "16-18", "12-14"],
        ["XL", "16-18", "16-18", "46-48", "20", "20", "16-18"],
        ["2XL", "20", "20", "50-52", "", "", "20"],
      ];
      needResize = false;
      $(".mibao_size_guide_2022 .guide_table .switch").hide(0);
      $(".mibao_size_guide_2022 .tips").hide(0);
    }
    let tableHtml = "";
    let tableFieldNameHtml = "";
    if (needResize) {
      // 数据转换，行列对调
      const sizeDataResize = [];
      for (let index in sizeData) {
        const item = sizeData[index];
        for (let key in item) {
          if (sizeDataResize[key] == undefined) {
            sizeDataResize[key] = [];
          }
          sizeDataResize[key][index] = item[key];
        }
      }
      sizeData = sizeDataResize;
    }

    // console.log(sizeDataResize)

    // for(let item of sizeData){
    for (let item of sizeData) {
      let tmp = `<tr><td>${item.slice(1).join("</td><td>")}</td></tr>`;
      let tmp2 = `<tr><td>${item[0]}</td></tr>`;
      tableHtml += tmp;
      tableFieldNameHtml += tmp2;
    }
    tableHtml = `<table>${tableHtml}</table>`;
    tableFieldNameHtml = `<table>${tableFieldNameHtml}</table>`;
    $(".mibao_size_guide_2022 .guide_table .content .data").html(tableHtml);
    $(".mibao_size_guide_2022 .guide_table .content .fixed_header").html(
      tableFieldNameHtml
    );
    // console.log(unit, sizeDataString, sizeData, tableHtml)

    $(".mibao_size_guide_2022 .tips span").hide();
    if (type == "size") {
      $(
        ".mibao_size_guide_2022 .guide_table .content .fixed_header table"
      ).addClass("size");
      $(".mibao_size_guide_2022 .guide_table .content .data table").addClass(
        "size"
      );
      $(".mibao_size_guide_2022 .guide_table .content .data td").each(
        function () {
          const val = $(this).text();
          if (["XS", "S", "M", "L", "XL", "XXL"].indexOf(val) > -1) {
            $(this).addClass(`size_color_${val.toLowerCase()}`);
          }
        }
      );
      $(".mibao_size_guide_2022 .tips span.size").show();
    } else {
      $(".mibao_size_guide_2022 .tips span.others").show();
    }
  }
  MB_jsDeferHandle(init, ["jQuery"]);
})();
